export default "__VITE_ASSET__Bm1IWh98__"